<template>
  <div class="com-banner">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "Banner"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.com-banner {
  $zoom: 1;
  width: 150%;
  height: 333px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background: linear-gradient(318deg, #1b7dfb 0%, #5274ff 100%);
  position: relative;
  /* z-index: 2; */
  margin-top: -86px;
  padding-top: 86px;
  border-radius: 0 0 150px 150px;
  margin-left: -25%;
}
</style>
